import React from 'react';
import { useTranslation } from 'react-i18next';

import { Fade } from '@material-ui/core';

import { Container, Search } from 'app/WMS/styles/styles';

import SearchBox from 'components/Tools/Search';
import FixedHeader from 'components/Tools/Breadcrumb';

import { useReportBatch } from './hooks/reportBatch.hooks';

import { IParamsGetBach } from './types';

import BatchTable from './components/TableBatch';

const ExitReport: React.FC = () => {
  const { t } = useTranslation();

  const {
    dateDay,
    searchRef,
    showTable,
    batchsData,
    structureOptions,
    handleSubmit,
    handleGetInputValue,
  } = useReportBatch();

  return (
    <>
      <FixedHeader
        title={t('screens.separation.reports')}
        subTitle={String(t('screens.reportReceipt.batch'))}
      />
      <Fade in timeout={1000}>
        <Container>
          <Search>
            <SearchBox
              handleSubmit={(data: IParamsGetBach) => handleSubmit(data)}
              searchBoxRef={searchRef}
              inputs={[
                {
                  name: 'codigoPedido',
                  label: String(t('screens.commom.order')),
                  placeholder: String(
                    t('screens.expeditionFollowUp.codeOrder')
                  ),
                  onChange: e => handleGetInputValue(e.target.value),
                  type: 'text',
                },
                {
                  name: 'produto',
                  label: String(t('screens.commom.product')),
                  placeholder: String(t('screens.receivement.enterProduct')),
                  onChange: e => handleGetInputValue(e.target.value),
                  type: 'text',
                },
                {
                  name: 'lote',
                  label: String(t('screens.reportReceipt.batch')),
                  placeholder: String(t('screens.reportReceipt.enterBach')),
                  type: 'text',
                },
                {
                  name: 'tipo',
                  label: String(t('screens.structureAdresses.type')),
                  placeholder: String(t('screens.structureAdresses.type')),
                  type: 'select',
                  options: structureOptions,
                },
                {
                  name: 'dataInicio',
                  label: String(t('screens.commom.initialDate')),
                  type: 'date',
                  defaultValue: dateDay,
                  xl: 4,
                  lg: 4,
                  xs: 12,
                  md: 4,
                  sm: 4,
                },
                {
                  name: 'dataFim',
                  label: String(t('screens.commom.finalDate')),
                  type: 'date',
                  defaultValue: dateDay,
                  xl: 4,
                  lg: 4,
                  xs: 12,
                  md: 4,
                  sm: 4,
                },
                {
                  name: 'serie',
                  label: String(t('screens.reportReceipt.series')),
                  placeholder: String(t('screens.reportReceipt.enterSeries')),
                  type: 'text',
                  xl: 4,
                  lg: 4,
                  xs: 12,
                  md: 4,
                  sm: 4,
                },
              ]}
            />
          </Search>
          {showTable && <BatchTable batchs={batchsData} />}
        </Container>
      </Fade>
    </>
  );
};

export default ExitReport;
